var map = {};
export default (function (prefix) {
    prefix = prefix || 'g';
    if (!map[prefix]) {
        map[prefix] = 1;
    }
    else {
        map[prefix] += 1;
    }
    return prefix + map[prefix];
});
//# sourceMappingURL=unique-id.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/unique-id.js
// module id = 531
// module chunks = 3